import { useEditContext } from '@components/utils/contexts/EditContext';
import { ROUTE_PRODUCT } from '@constants';
import { EmbedPostMessageEvent } from '@lib/embed/enums';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { postMessageToEmbed } from '@lib/embed/utils/postMessageToEmbed';
import { IconButton } from '@lib/uikit';
import { useRouter } from 'next/router';
import { FC } from 'react';

interface Props {
    beforeExit?: () => void;
}

export const ExitButton: FC<Props> = ({ beforeExit }) => {
    const { query, push } = useRouter();
    const { isEditMode } = useEditContext();
    const { isEmbedContextLoading, isStoryBundle } = useEmbedContext();

    if (isEditMode || isEmbedContextLoading) return null;

    const handleExit = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        beforeExit?.();
        if (isStoryBundle) {
            postMessageToEmbed(EmbedPostMessageEvent.DIALOG_CLOSE);
        } else {
            push({ pathname: ROUTE_PRODUCT, query }, `/${query.product}`);
        }
    };

    return (
        <IconButton
            ariaLabel='Close'
            icon='close'
            color='white'
            buttonSize='large'
            onClick={handleExit}
        />
    );
};
